import { type ReactNode } from 'react';
import { cn } from '~/utils';

interface RetryBannerProps {
  message: ReactNode;
  retryLabel: string;
  onRetry: () => void;
  testId?: string;
  className?: string;
}

export function RetryBanner({
  message,
  retryLabel,
  onRetry,
  testId,
  className,
}: Readonly<RetryBannerProps>) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-center gap-3 text-sm text-error-700',
        className
      )}
      data-testid={testId ? `${testId}-load-failed` : undefined}
    >
      {message}
      <button
        type="button"
        className="px-2 py-1 border border-neut-300 rounded text-xs text-neut-700 hover:bg-neut-100"
        data-testid={testId ? `${testId}-retry` : undefined}
        onClick={onRetry}
      >
        {retryLabel}
      </button>
    </div>
  );
}
